/* eslint-disable react/jsx-one-expression-per-line */
import { plural, Trans } from '@lingui/macro';
import React from 'react';
import { Link } from 'react-router-dom';

export function EndingSoonMessage({ trialDaysLeft }) {
    return (
        <Trans>
            Your free trial is ending in <strong>{trialDaysLeft} days</strong>.
        </Trans>
    );
}

export function EndedMessage({ days, isFreeTrial }) {
    if (!isFreeTrial) {
        return (
            <Trans>
                Your subscription ended <strong>{days} days ago</strong>.
            </Trans>
        );
    }
    return (
        <Trans>
            Your free trial ended <strong>{days} days ago</strong>.
        </Trans>
    );
}

export function CancelledGraceMessage({daysLeft}) {
    return (
        <Trans>
            Your subscription was cancelled and is expiring in <strong>{daysLeft} days</strong>.
        </Trans>
    );
}

export function ExpiringMessage({daysLeft}) {
    return (
        <Trans>
            Your subscription is expiring in <strong>{daysLeft} days</strong>.
        </Trans>
    );
}

export function PastDueMessage() {
    return (
        <Trans>
            You have a past-due payment for your subscription.
        </Trans>
    );
}

export function IncompleteMessage() {
    return (
        <Trans>
            You have an incomplete payment for your subscription.
        </Trans>
    );
}

function RemainingTime({ hrs, mins }) {
    if (hrs > 0) {
        return (
            <Trans>
                {plural(hrs, {
                    one: '# hr',
                    other: '# hrs',
                })}
            </Trans>
        );
    }

    return (
        <Trans>
            {plural(mins, {
                one: '# minute',
                other: '# minutes',
            })}
        </Trans>
    );
}

export function SubscribeMessage({
    type,
    time,
}) {
    switch (type) {
        case 'green':
            return (
                <Trans>
                    <Link to="/cp/subscription">Subscribe</Link> anytime and keep your trial period!
                </Trans>
            );
        case "orange":
            return (
                <Trans>
                    <Link to="/cp/subscription">Subscribe now</Link> to avoid interruption to the service.
                </Trans>
            );
        case "grace":
            return (
                <Trans>
                    <Link to="/cp/subscription">Subscribe now</Link> to avoid interruptions.
                </Trans>
            );
        case "red":
            return (
                <Trans>
                    <Link to="/cp/subscription">Subscribe Now</Link> to reactivate your account.
                </Trans>
            );
        case "pastDue":
            return (
                <Trans>
                    <Link to="/cp/subscription">Pay Now</Link> to avoid interruptions.
                </Trans>
            );
        case "incomplete":
            return (
                <Trans>
                    <Link to="/cp/subscription">Pay Now</Link> to avoid service interruption in&nbsp;
                    <RemainingTime hrs={time.hrs} mins={time.mins} />.
                </Trans>
            );
        default:
            return null;
    }
}
